<template>
  <div class="d-block form-group playhera-input m-0">
    <label :for="id" class="h-text-left pull-left username-label pb-2 m-0">
      {{ label }}
    </label>

    <div class="" :class="{ 'is-invalid': error }">
      <input
        class="new-username-input"
        :autocomplete="autocompleteOff ? 'new-password' : 'on'"
        :class="{ 'red-outline': error }"
        v-bind="{
          id,
          type,
          value,
          placeholder,
          tabindex,
          autofocus,
        }"
        @input="updateValue"
        @blur="onBlur"
        @focus="onFocus"
      />
    </div>
    <span
      v-show="(error, showError)"
      id="usernameHelp"
      class="form-text text-danger error-help"
      v-text="error"
    ></span>
  </div>
</template>
<script>
import { prop } from '@/utils/factories';

export default {
  $_veeValidate: {
    name() {
      return this.name;
    },
    value() {
      return this.value;
    },
  },
  props: {
    name: prop(String),
    id: prop(String, 'username-input'),
    label: prop(String),
    disabled: prop(Boolean),
    required: prop(Boolean),
    value: prop(String),
    type: prop(String, 'text'),
    error: prop(String),
    tabindex: prop(Number, -1),
    autofocus: prop(Boolean),
    placeholder: prop(String),
    autocompleteOff: prop(Boolean),
  },
  data() {
    return {
      showError: true,
    };
  },
  methods: {
    updateValue(e) {
      this.$emit('input', e.target.value);
    },
    onFocus() {
      this.$emit('focus');
      this.showError = false;
    },
    onBlur() {
      this.$emit('blur');
      this.showError = true;
    },
  },
};
</script>

<style lang="scss">
.new-username-input {
  border-radius: 0.25rem;
  background-color: $new-bg-base;
  width: 100%;
  height: 2.25rem;
  border: solid 1px;
  border-color: $new-border-neutral;
  padding: 0.5rem;
}
input::placeholder {
  color: $new-fg-neutral-faded;
}
.red-outline {
  border-color: rgb(223, 72, 95);
}
</style>
